import projection from '../generated/pwn5p1f1.json';
import { AcceptanceManifest } from '../types';
export const pwn5p1f1AcceptanceManifest = projection as AcceptanceManifest;
